import axios from 'axios';
import doaminConfig from '../config/config';
import storageUtils from './storageUtils';

// 测试地址
// axios.defaults.baseURL = '';    
// 线上地址
// axios.defaults.baseURL = '';  
// demo地址
// axios.defaults.baseURL = '';  
let axiosConfig = {
  timeout: 60 * 1000, // 超时时间
  // withCredentials: true, // Check cross-site Access-Control
};

// 创建axios实例
const _axios = axios.create(axiosConfig);

/**
 * 请求过滤器
 */
_axios.interceptors.request.use(
  (config) => {


    // 
    // 发起请求前拦截器，可以在这里添加header等
    // window.$$_web_env.apiDomain

    // 改成当前域名后面拼接/api
    // config.url = window.$$_web_env.apiDomain + config.url;
    // if (process.env.)
    // if (process.env.NODE_ENV === 'development') {
    //   config.url = window.$$_web_env.apiDomain + config.url;
    // } else {
    //   config.url = window.location.origin + '/api' + config.url;
    // }

    // 获取当前url
    if (config.url.indexOf('http') < 0) {
      const apiMap = doaminConfig.apiDomain;
      const pageDomain = window.location.origin;
      console.log('2222:', apiMap, pageDomain, apiMap[pageDomain]);
      if (apiMap[pageDomain]) {
        config.url = apiMap[pageDomain] + config.url;
      } else {
        config.url = pageDomain + config.url;
      }
    }

    return config;
  },
  (error) => {
    // 
    return Promise.reject(error);
  }
);

/**
 * 响应过滤器
 */
_axios.interceptors.response.use(
  async (response) => {
      if (response.config.responseType === 'blob') {
        let returnResult = {
          success: response.data && (response.status === 200),
          data: response.data ? response.data : null,
        };
        response.data = returnResult;
        return response;
      }
      // 将后端返回结果封装为IReturnResult对象
      let returnResult = {
        success: response.data && (response.data.code === 'success' || response.data.code === '000000'),
        errCode: response.data.code,
        errMsg: response.data ? (response.data.description ? response.data.description : response.data.message) : null,
        data: response.data ? response.data.data : null,
      };
      response.data = returnResult;
      return response;
    },
    (error) => {
      // 将错误信息封装为IReturnResult对象返回
      if (error.response) {
        if (error.response.status === 404) {
          let returnResult = {
            success: false,
            errCode: '404',
            errMsg: 'Page Not Found', // 这里应该是根据当前语言环境确定要赋予哪个语言的变量给errMsg，此处忽略了这个逻辑
            data: null,
          };
          error.response.data = returnResult;
        } else {
          let returnResult = {
            success: false,
            errCode: error.response.data.code,
            errMsg: error.response.data.description, // 这里应该是根据当前语言环境确定要赋予哪个语言的变量给errMsg，此处忽略了这个逻辑
            data: null,
          };
          error.response.data = returnResult;
        }

        return Promise.resolve(error.response); // 注意要用resolve，不用用reject，因为网络错误，这里也当做正确响应
      }

      return Promise.reject(error);
    }
);

/**
 * 设置请求header
 * @param contentType content-type
 */
const getHeader = (contentType = 'application/json') => {
  let header = {
    'Content-Type': contentType,
  };

  // 获取当前登录用户信息，将token放入header中
  try {

    const loginInfoStr = JSON.parse(storageUtils.get(doaminConfig.loginStorageKey));
    if (loginInfoStr && loginInfoStr.token) {
      header[doaminConfig.headerTokenKey] = loginInfoStr.token;
      // header.TOKEN = loginInfoStr.token;
    }
    // 临时写死的token
    // header[doaminConfig.headerTokenKey] = 'eyJhbGciOiJIUzI1NiJ9.eyJpZCI6MSwidXVpZCI6ImFiY2Rxd2VyIiwidXNlck5hbWUiOiJhZG1pbiIsInJlYWxOYW1lIjoiYWRtaW4iLCJtb2JpbGUiOiIxODEwODE3OTU0NiIsImlhdCI6MTYxODM4NjY3MCwiZXhwIjoxNjIwOTc4NjcwfQ.KqHNp7t7ItgNbXZPctcF-JV2Zpml7N5y3_l48hm0sCo';

  } catch (e) {

  }

  return header;
};

/**
 * 定义ajax方法
 */
var http = {
  /**
   * 发送get请求
   * @param url 请求地址，相对Url
   * @param params 请求参数，JSON对象
   */
  get: function (url, params) {
    params = params || {};
    return new Promise((resolve, reject) => {
      _axios.get(url, {
        params: params,
        headers: getHeader()
      }).then((res) => {
        resolve(res.data);
      }).catch((error) => {
        reject(error);
      });
    });
  },
  /**
   * 发送post请求
   * @param url 请求地址，相对url
   * @param data 请求数据，JSON对象
   */
  post: function (url, data) {
    data = data || {};
    return new Promise((resolve, reject) => {
      _axios.post(url, data, {
        headers: getHeader()
      }).then((res) => {
        resolve(res.data);
      }).catch((error) => {
        reject(error);
      });
    });
  },
  /**
   * 发送put请求
   * @param url 请求地址，相对url
   * @param data 请求数据，JSON对象
   */
  put: function (url, data) {
    data = data || {};
    return new Promise((resolve, reject) => {
      _axios.put(url, data, {
        headers: getHeader()
      }).then((res) => {
        resolve(res.data);
      }).catch((error) => {
        reject(error);
      });
    });
  },
  /**
   * 发送delete请求
   * @param url 请求地址，相对URL
   * @param data 请求数据，JSON对象
   */
  delete: function (url, data) {
    data = data || {};
    return new Promise((resolve, reject) => {
      _axios.delete(url, {
        params: data,
        headers: getHeader()
      }).then((res) => {
        resolve(res.data);
      }).catch((error) => {
        reject(error);
      });
    });
  },
  flowFileDownLoad: function (url, params) {
    params = params || {};
    return new Promise((resolve, reject) => {
      _axios.get(url, {
        responseType: 'blob',
        params: params,
        headers: getHeader()
      }).then((res) => {
        resolve(res.data);
      }).catch((error) => {
        reject(error);
      });
    });
  },
};

export default http;